import React from "react";
import firstdraft from "../../assets/firstdraft.jpg";
import headerImage from "../../assets/headerImage.jpg"; // Example header image

const Assignment1 = () => {
  return (
    <div className="container mx-auto my-8 px-5 max-w-3xl bg-gray-100 p-8 rounded-lg shadow-md">
      {/* Header */}
      <div className="relative mb-8">
        <img
          src={headerImage}
          alt="Header"
          className="w-full h-64 object-cover rounded-lg shadow-md"
        />
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black to-transparent p-6 rounded-b-lg">
          <h1 className="text-4xl font-bold text-bg-secondary"  style={{ textShadow: '2px 2px 4px rgba(0, 0, 0, 1)' }}>1. Week - Principles and Practices</h1>
          <p className="text-gray-300 mt-2">Published on: <span className="font-semibold">January 22, 2025</span></p>
          <div className="mt-4 flex space-x-4">
            <a
              //href="#concept"
              className="text-white bg-secondary  px-3 py-1 rounded hover:bg-secondary"
            >
              Initial Concept
            </a>
            <a
              //href="#mechanics"
              className="text-white bg-secondary px-3 py-1 rounded hover:bg-secondary"
            >
              Mechanical Construction
            </a>
            <a
              //href="#voice-control"
              className="text-white bg-secondary px-3 py-1 rounded hover:bg-secondary"
            >
              Voice Control
            </a>
          </div>
        </div>
      </div>

      {/* Abschnitt: Initial Concept */}
      <div id="concept" className="mb-6">
        <h2 className="text-2xl font-bold text-center mb-4">Initial Concept for My Final Project</h2>
        <p className="text-justify text-gray-700">
          This week’s task is to plan and sketch a potential final project. The idea for my project originated a few months ago while I was working at the MakerFaire in Hannover. During the event, I had the opportunity to meet a group of R2D2 builders who showcased their impressive robot creations. I was truly fascinated by the level of craftsmanship and detail in their designs. However, as I learned more about their robots, I discovered that they were entirely radio-controlled, with no capability for autonomous movement. This limitation struck me as a missed opportunity, and I couldn’t help but feel a bit disappointed.
        </p>
        <p className="text-justify text-gray-700 mt-4">
          That moment sparked an idea: what if there was a way to create a robot companion that could navigate autonomously in a real-life environment? The thought stayed with me, and I began to imagine a robot that could follow its owner wherever they went, carrying their belongings and making their day-to-day life easier.
        </p>
        <p className="text-justify text-gray-700 mt-4">
          As I continued to think about it, the concept evolved into something even more versatile and practical. Beyond just being a robotic companion, such a device could integrate with modern technology to serve as a digital assistant. For instance, through voice control and smartphone connectivity, it could assist with hands-free tasks like taking notes or managing reminders. This would allow the user to stay focused on their activities without needing to stop and interact with their phone, reducing distractions.
        </p>
      </div>

      {/* Abschnitt: First Draft */}
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-center mb-4">First Draft of My Final Project</h2>
        <p className="text-justify text-gray-700">
          Although my painting skills are almost non-existent, I started with a sketch to visualize my idea.
        </p>
        <div className="flex justify-center mt-4">
          <img
            src={firstdraft}
            alt="First Draft"
            className="rounded-lg shadow-md max-w-full h-auto"
          />
        </div>
      </div>

      {/* Abschnitt: Basic Concept */}
      <div id="mechanics" className="mb-6">
        <h2 className="text-2xl font-bold text-center mb-4">Basic Concept</h2>
        <p className="text-justify text-gray-700">
          The core idea of the Robo-Buddy is to create a small, autonomous companion robot capable of following its user by tracking a wearable device, such as a Bluetooth-enabled wristband. The wristband acts as a guide, emitting signals that the robot uses to determine the user’s position in real time. This allows the robot to follow you wherever you go, with sensors like ultrasonic sensors helping to navigate around obstacles and adapting to changes in the environment.
        </p>
      </div>

      {/* Abschnitt: Mechanical Construction */}
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-center mb-4">Mechanical Construction</h2>
        <p className="text-justify text-gray-700">
          The mechanical construction of the Robo-Buddy begins with a robust aluminum chassis, which forms the foundation of the robot. A circular base plate with a diameter of approximately 360mm provides the necessary stability and durability. This aluminum plate is designed to accommodate mounts for the rear DC motor(s) and the front servo-controlled wheels. In addition, it has the possibility to attach the 3D printed body parts.
        </p>
        <p className="text-justify text-gray-700 mt-4">
          The main body of the robot is constructed from modular 3D-printed parts. These cylindrical segments are designed to stack horizontally and vertically, ensuring the capability to build the robot's body in an appropriate size. The top of the robot consists of an aluminum dome with a diameter of 360mm and a height of 160mm. Four metal rods connect the two plates and provide stability for the case.
        </p>
      </div>

      {/* Abschnitt: RF Bracelet */}
      <div id="voice-control" className="mb-6">
        <h2 className="text-2xl font-bold text-center mb-4">RF Bracelet</h2>
        <p className="text-justify text-gray-700">
          The RF Bracelet serves as the guiding device for the Robo-Buddy, emitting signals that allow the robot to track the user's position in real time.
        </p>
      </div>

      {/* Abschnitt: Voice Control and Connectivity */}
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-center mb-4">Voice Control and Connectivity</h2>
        <p className="text-justify text-gray-700">
          By integrating voice control and smartphone connectivity, the Robo-Buddy can function as a digital assistant, enabling hands-free tasks such as note-taking, managing reminders, and more.
        </p>
      </div>
    </div>
  );
};

export default Assignment1;
